module.exports = __webpack_public_path__ + "mp3/The_Plan_s_Working.mp3";